import React, { useEffect, useState } from 'react';
import ApplyCSS from '.';
import CommonUtil from '../../utils/commonUtil';

export default function CSSWrapper({ pageName, content }) {
  const [cssReady, setCssReady] = useState(false);

  useEffect(() => {
    // Wait for the Helmet links to be injected first
    const checkLinks = () => {
      const cssLinks = document.querySelectorAll('link[rel="stylesheet"]');
      let loaded = 0;

      const markReady = () => {
       setCssReady(true);
        setTimeout(() => {
          if (document.getElementById('event-cards')) {
               document.getElementById('event-cards').style.display = 'flex';
          }
        }, 1000);
      };

      if (cssLinks.length === 0) {
        markReady();
        return;
      }

      cssLinks.forEach(link => {
        if (link.sheet) {
          // already loaded (cache)
          loaded++;
          if (loaded === cssLinks.length){
             markReady();
          }
        } else {
          const onLoad = () => {
            loaded++;
            if (loaded === cssLinks.length){
                markReady();
            }
            link.removeEventListener('load', onLoad);
          };
          link.addEventListener('load', onLoad);
        }
      });
    };

    // Run once Helmet has updated the DOM
    const timer = setTimeout(checkLinks, 0);
    return () => clearTimeout(timer);
  }, []);

  if (!cssReady) {
    return (
      <div id="loading-wrapper">
        <img id="loading-image-wrapper" src={CommonUtil.getAssetURL() + '/images/bx_loader.gif'} alt="Loading --CSS…" />
      </div>
    );
  }

  return <ApplyCSS pageName={pageName} title={content?.[0]?.title} />;
}
